<template>
    <div class="modal">

        <button class="close-btn" @click="onClose">&#x2A09;</button>   
        <div class="modal-content">
            <img :src="img_url">
        </div>
    </div>
    
</template>

<script>
export default {
    name: "modal",
    props: ["img_url"],
    methods: {
        onClose() {
            this.$emit('modal-onclose');
        }
    }
}
</script>

<style lang="scss" scoped>
    .modal {
        position: fixed;
        top:0;
        left: 0;
        z-index: 9999;

        background-color: rgba(0, 0, 0, 0.281);
        width: 100vw;
        height: 100vh;


        .close-btn {
            position: absolute;
            top: 0;
            right: 0.5em;
            color: white;
            
            background: none;
            font-size: 100px;

            &:hover {
                color: black;
            }
        }

        .modal-content {
            width: 100%;
            height: 100%;
            display: flex;

            justify-content: center;
            align-items: center;

            img {
                max-width: 90vw;
                max-height: 90vh;
            }
        }
    }
</style>